@if (isInvalid) {
  <div class="p-1 text-sm text-red-500">
    @if (controlErrors.includes("required")) {
      {{ "validationError.required" | transloco }}
    } @else if (controlErrors.includes("min")) {
      {{ "validationError.min" | transloco }}
      {{ this.control.errors?.["min"].min }}
    } @else if (controlErrors.includes("durationInvalid")) {
      {{ "validationErrors.durationInvalid" | transloco }}
    } @else if (controlErrors.includes("invalidAddress")) {
      {{ "validationError.invalidAddress" | transloco }}
    } @else if (controlErrors.includes("invalidItinerary")) {
      {{ "validationError.invalidItinerary" | transloco }}
    } @else if (controlErrors.includes("max")) {
      {{ "validationError.max" | transloco }}
      {{ this.control.errors?.["max"].max }}
    }
  </div>
}
